import * as React from "react";

import Maintenance from "../components/Maintenance";

const MaintenancePage: React.FC = () => {
	return <Maintenance />;
};

export default MaintenancePage;
